module.exports = __webpack_public_path__ + "static/media/desktop_background.cce0efd5.jpg";